import contextMenu from 'helpers/styles/contextMenu'

export default {
  cameraLabel: {
    color: '#444',
    backgroundColor: 'white',
    fontSize: 10,
    textAlign: 'center',
    padding: 2,
    border: '1px solid black',
    whiteSpace: 'nowrap'
  },
  ...contextMenu
}



// WEBPACK FOOTER //
// ./src/components/Camera/style.js